/**
 * Espera curta DENTRO de um controle (contrato `Spinner` do catalogo do design system).
 *
 * PROMOVIVEL: nao sabe o que esta carregando.
 *
 * Nunca aparece sozinho. O design system corta animacao em `prefers-reduced-motion`, entao um giro
 * mudo deixaria a pessoa sem informacao nenhuma - por isso o componente sempre vem acompanhado de
 * um rotulo (visivel ou so para leitor de tela), e o giro e enfeite.
 *
 * SEGUNDA COPIA (a primeira e do New Inteli Graph). Copiado, e nao reescrito, de proposito: os dois
 * apps precisam da mesma peca e o design system ainda nao a exporta. **Na terceira copia, sobe para
 * `@ledger-glass/react`** - tres implementacoes da mesma coisa divergem, duas ainda se mantem em dia.
 */

export interface SpinnerProps {
  /** O que esta acontecendo. Vai para o leitor de tela e, com `showLabel`, para a tela. */
  label: string
  showLabel?: boolean
  size?: 'small' | 'default'
}

export function Spinner({ label, showLabel = false, size = 'default' }: SpinnerProps) {
  return (
    <span className={`spinner spinner--${size}`} role="status">
      <span className="spinner__disc" aria-hidden="true" />
      <span className={showLabel ? 'spinner__label' : 'sr-only'}>{label}</span>
    </span>
  )
}
